<template>
	<div id="sm-editor"></div>
</template>

<script>
export default {
    props:{
        value:{
            type:String,
            required:true
        },
        def:{
	        type:String,
	        default: ''
	    },
        name:String,
        theme:String,
    },
    data: function () {
        return {
            editor:null,
            contentBackup:""
        }
    },
    watch:{
        value:function (val) {
            if(this.contentBackup !== val)
                this.editor.setValue(val,1);
        }
    },
    mounted: function () {
        var self = this;

        var editor = self.editor = ace.edit(this.$el);
        editor.setShowPrintMargin(false);
        editor.setTheme("ace/theme/tomorrow_night");
        editor.getSession().setMode("ace/mode/twig");
        editor.renderer.setScrollMargin(5, 5, 0, 0);

		this.$emit('init', editor);
        this.$emit('input', this.def);
                
        editor.$blockScrolling = Infinity;
        editor.setValue(this.value,1);

        editor.on('change',function () {
            var content = editor.getValue();
            self.$emit('input',content);
            self.$emit('change',content);
            self.contentBackup = content;
        });


    }
}
</script>


// WEBPACK FOOTER //
// AceEditor.vue?07f3bc40